<template>
  <div class="bank">
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    >
    </sirui-search>
    <!-- 表格 -->
    <div>
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          :loading="load"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="true"
          :columns="columnList"
          :valid-config="{ autoPos: true, message: 'inline' }"
          :showToolbar="true"
          @chooseClick="chooseClick"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field === 'bankStatus'">
                {{ bankStatusObj[scope.row[item.field]] }}
              </span>
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
    <!-- 上传组件 -->
    <el-upload
      style="display: none"
      ref="siruiUpload"
      :data="uploadData"
      :action="uploadUrl"
      accept=".xls,.xlsx"
      :before-upload="uploadBefore"
      :on-success="uploadSuccess"
      :show-file-list="false"
      :with-credentials="true"
      :on-error="uploadError"
    >
      <el-button ref="importBtn"></el-button>
    </el-upload>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/masterData/bank';
  import { mapState } from 'vuex';
  import baseUrl from '@/common/config';
  export default {
    name: 'bank',
    components: {
      SiruiSearch,
      SiruiTable,
    },
    computed: {
      searchColumns() {
        return [
          { name: '银行类别', prop: 'bankName', type: 'input' },
          { name: '银行名称', prop: 'branchName', type: 'input' },
          { name: this.$t('bank.label.bankUnionNumber'), prop: 'bankUnionNumber', type: 'input' },
          { name: this.$t('bank.label.swiftCode'), prop: 'swiftCode', type: 'input' },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        searchForm: {
          bankName: null,
          branchName: null,
          bankUnionNumber: null,
          swiftCode: null,
        },
        load: false,
        tableData: [],
        multipleSelection: [],
        uploadData: {}, // 上传参数
        uploadUrl: '',
        menuButtonList: [],
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
            disabled: true,
          },
          {
            field: 'bankName',
            title: '银行类别',
            visible: true,
          },
          {
            field: 'bankCode',
            title: 'bank.label.bankCode',
            visible: true,
          },
          {
            field: 'bankRegion',
            title: 'bank.label.bankRegion',
            visible: true,
          },
          {
            field: 'bankStreet',
            title: 'bank.label.bankStreet',
            visible: true,
          },
          {
            field: 'bankCity',
            title: 'bank.label.bankCity',
            visible: true,
          },
          {
            field: 'branchName',
            title: '银行名称',
            visible: true,
          },
          {
            field: 'bankUnionNumber',
            title: 'bank.label.bankUnionNumber',
            visible: true,
          },
          {
            field: 'swiftCode',
            title: 'bank.label.swiftCode',
            visible: true,
          },
          {
            field: 'bankGroup',
            title: 'bank.label.bankGroup',
            visible: true,
          },
          {
            field: 'bankStatus',
            title: 'bank.label.bankStatus',
            visible: true,
          },
        ],
        bankStatusObj: {
          '01': this.$t('bank.message.overSvae'),
          '02': this.$t('bank.message.reject'),
        },
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      // this.getDictData();
      this.uploadUrl = baseUrl + API.IMPORT_SYSBANK;
    },
    methods: {
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { bankName, branchName, bankUnionNumber, swiftCode } = this.searchForm;
        const params = { pageNum, pageSize, bankName, branchName, bankUnionNumber, swiftCode };
        this.$axios.post(API.GET_LIST_BANK, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e || [];
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.columnList = this.columnListDefault;
        this.columnList.forEach((item) => {
          if (this.userInfo.adminFlag == 2 && item.type == 'checkbox') {
            item.visible = false;
          }
        });
        // this.getColumnList(this.columnListDefault).then((res) => {
        //   this.columnList = res;
        //   this.columnList.forEach((item) => {
        //     if (this.userInfo.adminFlag == 2 && item.type == 'checkbox') {
        //       item.visible = false;
        //     }
        //   });
        // });
      },
      // 获取字典表
      // getDictData() {
      //   let params = {
      //     tenantCode: this.userInfo.tenantCode,
      //     dictType: "request_status"
      //   }
      //   this.$axios.post(API.DICT_LIST, params).then(res => {
      //     if (res.data.code === 0) {
      //       res.data.data.forEach(item => {
      //         this.bankStatusObj[item["value"]] = item["label"];
      //       })
      //     } else {
      //       this.$message({ showClose: true, message: res.data.msg, type: "error" });
      //     }
      //   });
      // },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      chooseClick(value) {
        if (value === 'forbid') {
          this.handleEnableOrForbid('02');
        } else if (value === 'enable') {
          this.handleEnableOrForbid('01');
        } else if (value === 'import') {
          this.handleImport();
        }
      },
      // 启用/禁用
      handleEnableOrForbid(value) {
        // 01 生效， 02禁用
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('bank.message.noSelected'),
            type: 'error',
          });
          return;
        }
        const arr = [];
        this.multipleSelection.forEach((item) => {
          arr.push(item.id);
        });
        const params = {
          bankStatus: value,
          ids: arr,
        };
        this.$axios.post(API.UPDATE_SYSBANK, params).then((res) => {
          if (res.data.code === 0) {
            this.getData();
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 导入
      handleImport() {
        const {
          access_token,
          tenantCode,
          companyCode,
          departmentCode,
          companyName,
          departmentName,
        } = this.userInfo;
        this.uploadData = {
          lang: this.$store.getters.language,
          access_token,
          tenantCode,
          companyCode,
          departmentCode,
          companyName,
          departmentName,
        };
        this.$refs.importBtn.$el.click();
      },
      // 开始上传
      uploadBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      uploadSuccess(response) {
        this.loading.endLoading();
        if (response.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t('bank.message.importSuccess'),
            type: 'success',
          });
          this.getData();
        } else {
          this.$alert(response.msg);
          if (response.data) {
            window.location.href = `${response.data}`;
          }
        }
      },
      // 上传错误
      uploadError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      // 修改每页条数
      handleSizeChange() {
        this.getData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
      // 表格选择行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>

<style scoped></style>
